import React from 'react';
import { WifiOff, RefreshCw, CheckCircle } from 'lucide-react';
import { useOffline } from '../contexts/OfflineContext';

const OfflineStatusBanner: React.FC = () => {
  const { isOnline, pendingActions, lastSyncAt, processQueue } = useOffline();

  const pendingCount = pendingActions.length;
  const showBanner = !isOnline || pendingCount > 0;

  if (!showBanner) {
    return null;
  }

  const formattedSync =
    lastSyncAt != null ? new Date(lastSyncAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '—';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: isOnline ? '#ecfccb' : '#fee2e2',
        color: isOnline ? '#3f6212' : '#b91c1c',
        border: `1px solid ${isOnline ? '#a3e635' : '#fecaca'}`,
        borderRadius: '9999px',
        padding: '6px 14px',
        fontSize: '13px',
        fontWeight: 500,
      }}
    >
      {isOnline ? <CheckCircle size={16} /> : <WifiOff size={16} />}
      <span>
        {isOnline
          ? pendingCount > 0
            ? `${pendingCount} ${pendingCount === 1 ? 'ação pendente' : 'ações pendentes'}`
            : 'Online'
          : 'Modo offline'}
      </span>
      {pendingCount > 0 && (
        <button
          onClick={processQueue}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '4px 10px',
            borderRadius: '9999px',
            border: 'none',
            backgroundColor: '#2563eb',
            color: 'white',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 600,
          }}
          disabled={!isOnline}
        >
          <RefreshCw size={14} />
          Sincronizar
        </button>
      )}
      <span style={{ fontSize: '12px', color: isOnline ? '#4d7c0f' : '#b45309' }}>
        Última sync: {formattedSync}
      </span>
    </div>
  );
};

export default OfflineStatusBanner;

